import 'bootstrap/dist/css/bootstrap.min.css';
import LeftMenu from './components/LeftMenu';
import Login from './Login.jsx'

import {
  BrowserRouter,
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
} from 'react-router-dom';
import HomePage from './pages/HomePage';
import TotalProcessed from './pages/TotalProcessed';
import Landing from './pages/Landing';
import React from 'react';
import TotalProcess from './pages/TotalProcess';
import RouterLibrary from './RouterLibrary';
import WarningModal from './components/WarningModal.jsx';
import { useModal } from './context/WarningModalContext.jsx';
// import { LoadingIndicator } from 'react-select/dist/declarations/src/components/indicators';


function App() {
  const { isModalOpen, hideModal } = useModal();
  return (

    <div className="App">
       <WarningModal isOpen={isModalOpen} onClose={hideModal} />
      <RouterLibrary />

    </div>
  );
}

export default App;